import React, { MouseEventHandler } from 'react';
import { Filter } from '@procore/core-icons/dist';
import { Button, useI18nContext } from '@procore/core-react';
import classNames from 'classnames';
import { useStyles } from './MobileFiltersButton.styles';

interface MobileFiltersButtonProps {
  handleClick: MouseEventHandler<HTMLButtonElement>;
  numFiltersSelected: number;
}

export default function MobileFiltersButton({
  handleClick,
  numFiltersSelected,
}: MobileFiltersButtonProps) {
  const I18n = useI18nContext();
  const classes = useStyles();
  return (
    <Button
      icon={<Filter />}
      onClick={handleClick}
      data-test-id="filter-button"
      variant="secondary"
      className={classNames(
        classes.filterButton,
        numFiltersSelected > 0 ? classes.filterButtonBlue : ''
      )}
    >
      {numFiltersSelected > 0
        ? I18n.t('components.filters.filter_count', {
            count: numFiltersSelected,
          })
        : I18n.t('components.filters.filter')}
    </Button>
  );
}
